"use client"

import React, { useEffect, useState } from "react";
import styles from './Dropdown.module.css'

export default function Dropdown({ options, children }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);

  // if any click except on toggle button, close dropdown
  useEffect(() => {
    const handleClick = (event) => {
      if (event.target instanceof HTMLElement) {
        if (event.target.classList.contains(styles.toggle) || (event.target.parentElement && event.target.parentElement.classList.contains(styles.toggle))) {
          return;
        }
      }
      close();
    };
    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <div className={styles.container}>
      <button className={styles.toggle} onClick={toggle}>
        {children}
      </button>
      <ul className={`${styles.menu} ${isOpen && styles.menuOpen}`}>
        {options.map((option, i) => (
          <li key={i}>
            {option.onClick ?
              <button onClick={() => option.onClick()}>
                {option.name}
              </button>
              :
              <a href={option.path}>
                {option.name}
              </a>
            }
          </li>
        ))}
      </ul>
    </div>
  );
};